<template>
  <header
    v-click-outside="hideMenu"
    class="sociolla-universe-v1"
    :class="{ 'sociolla-universe-v1-min-height-home': !isDesktop && $route.name === 'Dashboard' }"
  >
    <div :id="!screen.isDesktop ? 'main_header__v2' : ''" class="header--uniform" :class="{ sticky: !isDesktop }">
      <div
        v-if="!kebabMenuShowPagesList && !closeButton"
        class="container make-relative"
        :class="{ homepage: !isDesktop && $route.name === 'Dashboard' }"
      >
        <div class="header-wrap header--soco" :class="{ 'register-profile': registerProfilePages }">
          <template v-if="!registerProfilePages || (registerProfilePages && screen.isDesktop)">
            <div v-if="!registerProfilePages || (registerProfilePages && screen.isDesktop)" class="row">
              <div class="col-xs-left col-xs-12 col-sm-2 col-md-2 col-lg-2">
                <a
                  v-if="!screen.isDesktop"
                  href
                  class="hamburger-menu icon-block"
                  :class="[{ active: isOffCanvasOpen }, { white: !isDesktop && $route.name === 'Dashboard' }]"
                  @click.prevent="toggleOffCanvas($event)"
                >
                  <span class="toggle-menu cmn-toggle-switch cmn-toggle-switch__htx">
                    <span>MENU</span>
                  </span>
                </a>
                <router-link class="logo" to="/">
                  <!-- <img src="/assets/img/logo-header-review.svg"> -->
                  <SvgImg v-if="isDesktop" id="logo-header-review" name="logo-header-review" width="120" height="38" />
                  <SvgImg
                    v-else-if="!isDesktop && $route.name === 'Dashboard'"
                    id="logo-header-review-white"
                    name="logo-header-review-white"
                    width="90"
                    height="33"
                  />
                  <SvgImg v-else id="logo-header-review" name="logo-header-review" width="90" height="33" />
                </router-link>
              </div>

              <div
                v-if="!registerProfilePages"
                id="searchArea"
                class="col-xs-center col-xs-12 col-sm-5 col-md-5 col-lg-6"
                :class="{ active: searchPopup }"
              >
                <div class="input-search-header">
                  <a v-if="!screen.isDesktop" href="" @click.prevent="hideSearchPopup">
                    <img src="/assets/img/arrow_left_new.svg" class="back-action" />
                  </a>
                  <input
                    v-model="querySearch"
                    type="text"
                    class="form-control"
                    placeholder="Search..."
                    autocomplete="off"
                    @focus="
                      fetchFocus();
                      showSearchPopup();
                    "
                    @keyup="searchSuggestion($event)"
                    @keyup.exact="fetchSuggestion($event)"
                    @keyup.enter="searching()"
                  />
                  <!-- @blur="hideSearchPopup()" -->

                  <transition name="fade">
                    <div
                      v-if="searchPopup"
                      ref="sectionSuggested"
                      class="search-suggest"
                      :class="{ 'no-result': noResultSearch }"
                    >
                      <SearchPlaceholder v-if="initialLoading || searchLoading" />
                      <!-- LOADING -->
                      <div v-else>
                        <!-- SUGGESTED CATEGORIES -->
                        <div
                          v-if="suggestions.category && suggestions.category.length"
                          class="result-category suggestion-results"
                        >
                          <ul class="list-suggest-category">
                            <li v-for="(category, key) in suggestions.category" :key="key">
                              <router-link
                                :key="key + 'srb'"
                                :to="`/search?query=${category.name}`"
                                class="category-logo-wrapper"
                                @click.native="saveCategoriesToHistory(category)"
                              >
                                <SvgImg class="lazy-img" name="magnify-glass" width="14" height="14" />
                                <!-- eslint-disable-next-line vue/no-v-html-->
                                <span v-html="partialBold(category.name)"></span>
                              </router-link>
                            </li>
                          </ul>
                        </div>

                        <!-- SUGEESTED SKIN CONCERN -->
                        <div v-if="suggestedTag.length" class="result-category suggestion-results">
                          <ul class="list-suggest-category">
                            <li v-for="(tag, key) in suggestedTag" :key="`suggest-tag-concern${key}`">
                              <!-- <router-link :to="`/tag/${tag.url_search}`" class="category-logo-wrapper"> -->
                              <router-link :to="`/search?query=${tag.url_search}`" class="category-logo-wrapper">
                                <img
                                  v-if="tag.icon"
                                  :src="tag.icon"
                                  class="tag-icon"
                                  :alt="'Concern - ' + tag.name"
                                />{{ tag.name }}
                              </router-link>
                            </li>
                          </ul>
                        </div>

                        <!-- SUGGESTED BRANDS -->
                        <div v-if="querySearch.length > 1" class="search-result-wrap">
                          <div
                            v-if="suggestions.brands && suggestions.brands.length"
                            class="result-popular-brands suggestion-results"
                          >
                            <h4 class="suggestion-results__heading">suggested brand</h4>
                            <ul class="list-popular-brand list-scrollable">
                              <li
                                v-for="(b, idx) in suggestions.brands"
                                :key="idx"
                                @click="saveSearchHistoryClicks(b._id, 'brand')"
                              >
                                <router-link
                                  class="brand-logo-wrapper"
                                  :to="`/brand/${b.my_soco_sql_id}/${$options.filters.slug(b.name)}`"
                                >
                                  <img
                                    v-if="b.logo"
                                    :src="mainImage(b.logo)"
                                    :alt="'Sociolla - ' + b.name"
                                    class="brand-logo"
                                    @error="brandImageErrorHandler($event)"
                                  />
                                  <img
                                    v-else
                                    src="/assets/img/dummy_product.svg"
                                    class="brand-logo error-brand"
                                    alt="no image"
                                  />
                                </router-link>
                              </li>
                            </ul>
                          </div>

                          <div
                            v-if="suggestions.products && suggestions.products.length"
                            class="result-trending-products suggestion-results suggestion-results--suggestion-products"
                          >
                            <h4 class="suggestion-results__heading">suggested product</h4>
                            <ul class="list list-trending-products list-suggestion-products">
                              <li
                                v-for="(prodRslt, idx) in suggestions.products"
                                :key="idx"
                                @click="saveSearchHistoryClicks(prodRslt.id, 'product')"
                              >
                                <GProduct
                                  v-if="prodRslt"
                                  :inline-reviewers="true"
                                  :hide-average-rating="false"
                                  class="list-to-review__nowrap"
                                  class-modifier="product--inline-navbar"
                                  :hide-total-reviews="true"
                                  :hide-combinations="true"
                                  :right-btn-review="true"
                                  :product="prodRslt"
                                  :section="`navbar`"
                                />
                              </li>
                            </ul>
                            <!-- <infinite-loading @infinite="infiniteHandler">
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                                <div slot="spinner"><GLoaderSpin /></div>
                              </infinite-loading> -->
                          </div>
                        </div>

                        <div v-if="!querySearch" class="search-result-wrap">
                          <template v-if="isLogin">
                            <div v-if="recentlySearch.length" class="result-recently-search suggestion-results">
                              <h4 class="suggestion-results__heading">
                                recently searched
                                <span
                                  v-if="recentlySearch.length"
                                  class="result-recently-search__clear"
                                  @click.prevent="clear"
                                >
                                  Clear
                                </span>
                              </h4>

                              <ul class="list-scrollable list-recently-search">
                                <li v-for="(history, key) in recentlySearch" :key="`list-recently-search${key}`">
                                  <router-link
                                    :to="`/search?query=${history.keyword}`"
                                    class="pill pill__recently-search pill--with-close"
                                  >
                                    {{ history.keyword }}
                                    <span
                                      class="pill__dismiss"
                                      @click.prevent="remove({ key: key, history: history })"
                                    ></span>
                                  </router-link>
                                </li>
                              </ul>
                            </div>
                            <div v-else class="result-recently-search suggestion-results">
                              <LoaderSpin key="isLoadingRecentylySearch" />
                            </div>
                          </template>

                          <template v-if="isLogin">
                            <div v-if="recentlyProductViewed.length" class="result-recently-view suggestion-results">
                              <h4 class="suggestion-results__heading">recently viewed</h4>
                              <ul class="list-scrollable list-recently-viewed">
                                <li v-for="(recentlyReview, key) in recentlyProductViewed" :key="key">
                                  <router-link
                                    v-if="recentlyReview.product && recentlyReview.product.is_active_in_review"
                                    :to="$options.filters.productUrlReview(recentlyReview.product)"
                                    target="_blank"
                                    rel="noopener"
                                  >
                                    <figure class="product-image">
                                      <img
                                        v-if="
                                          recentlyReview.product.product_images &&
                                          recentlyReview.product.product_images.length > 0 &&
                                          recentlyReview.product.product_images[0].url
                                        "
                                        :src="mainImage(recentlyReview.product.product_images[0].url)"
                                        alt=""
                                        width="50"
                                      />
                                      <img v-else src="https://images.soco.id/300x300.png" width="50" />
                                    </figure>
                                  </router-link>
                                  <a
                                    v-else
                                    :href="$options.filters.productLinkV3(recentlyReview.product)"
                                    target="_blank"
                                    rel="noopener"
                                  >
                                    <figure class="product-image">
                                      <img
                                        v-if="
                                          recentlyReview.product.product_images.length > 0 &&
                                          recentlyReview.product.product_images[0].url
                                        "
                                        :src="recentlyReview.product.product_images[0].url"
                                        alt=""
                                        width="50"
                                      />
                                      <img v-else src="https://images.soco.id/300x300.png" width="50" />
                                    </figure>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </template>

                          <!-- TRENDING SEARCH -->
                          <div
                            v-if="trendingSearchData && trendingSearchData.length"
                            class="result-recently-search suggestion-results"
                          >
                            <h4 class="suggestion-results__heading">trending search</h4>
                            <ul ref="list-trending-search--result" class="list-scrollable list-recently-search">
                              <li
                                v-for="(trending, key) in trendingSearchData"
                                :key="`list-trending-search--result${key}`"
                              >
                                <router-link :to="`/search?query=${trending}`" class="pill pill__tags">
                                  <img src="/assets/img/popular.svg" alt="Popular" class="tag-icon" />
                                  {{ trending }}
                                </router-link>
                              </li>
                            </ul>
                          </div>

                          <div v-if="tagConcern.length" class="result-recently-search suggestion-results">
                            <h4 id="review-tag-0" class="suggestion-results__heading">skin concern</h4>
                            <ul class="list-scrollable list-recently-search">
                              <li v-for="(tag, key) in tagConcern" :key="`list-tag-concern${key}`">
                                <!-- <router-link :to="`/tag/${tag.url_search}`" class="pill pill__tags"> -->
                                <router-link :to="`/search?query=${tag.url_search}`" class="pill pill__tags">
                                  <img
                                    v-if="tag.icon"
                                    :src="tag.icon"
                                    class="tag-icon"
                                    :alt="'Concern - ' + tag.name"
                                  />{{ tag.name }}
                                </router-link>
                              </li>
                            </ul>
                          </div>

                          <div class="result-popular-brands suggestion-results">
                            <h4 class="suggestion-results__heading">popular</h4>
                            <ul class="list-popular-brand list-scrollable">
                              <li v-for="(b, idx) in exclusiveAndTrendingTabs[activeTab].brands" :key="idx">
                                <!-- <router-link class="brand-logo-wrapper" :to="`/brand/${b.my_soco_sql_id}/${b.name}`"> -->
                                <router-link class="brand-logo-wrapper" :to="`/search?query=${b.name}`">
                                  <img
                                    v-if="b.logo"
                                    :src="mainImage(b.logo)"
                                    alt="Sociolla - Maybelline"
                                    class="brand-logo"
                                    @error="brandImageErrorHandler($event)"
                                  />
                                  <img
                                    v-else
                                    src="/assets/img/dummy_product.svg"
                                    class="brand-logo error-brand"
                                    alt="no image"
                                  />
                                </router-link>
                              </li>
                            </ul>
                          </div>

                          <div class="result-trending-products suggestion-results">
                            <ul class="list list-trending-products">
                              <li
                                v-for="(product, index) in exclusiveAndTrendingTabs[activeTab].products"
                                :key="index"
                                @click="saveSearchHistoryClicks(product.id, 'product')"
                              >
                                <GProduct
                                  :inline-reviewers="true"
                                  :hide-average-rating="false"
                                  class="list-to-review__nowrap"
                                  class-modifier="product--inline-navbar"
                                  :hide-total-reviews="true"
                                  :hide-combinations="true"
                                  :right-btn-review="true"
                                  :product="product"
                                  :section="`navbar`"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>

                        <template
                          v-if="
                            noResultSearch &&
                            !(suggestions.products && suggestions.products.length) &&
                            !(suggestions.brands && suggestions.brands.length)
                          "
                        >
                          <!-- NO RESULT FOUND -->
                          <div class="no-result-found">
                            <div class="no-result-found--image">
                              <SvgImg class="lazy-img" name="product-not-found" width="72" height="65" />
                            </div>
                            <p class="no-result-found--text">Sorry dear, no suggestion found</p>
                            <p class="no-result-found--subtext">
                              We cant find any brand & product matching your search
                            </p>
                          </div>
                        </template>
                      </div>
                    </div>
                  </transition>
                </div>
                <ButtonCreate key="buttonCreateDesktop" />
              </div>

              <div v-if="!registerProfilePages" class="col-xs-right col-xs-12 col-sm-5 col-md-5 col-lg-4">
                <template v-if="!screen.isDesktop">
                  <!-- <span
                    id="searchIconArea"
                    class="basic-icon--uniform"
                    :class="!searchPopup ? 'icon-search' : 'icon-close'"
                    @click.prevent="toggleInputSearchMobile($event)"
                  ></span> -->

                  <ButtonCreate key="buttonCreateMobile" class="mobile" />
                </template>
                <template v-else>
                  <div v-if="isLogin" class="right user-account">
                    <div class="header-profile user-menu">
                      <div class="username">
                        <i>Hi,</i>
                        <div class="userfullname">{{ auth.userFullName }}</div>
                      </div>
                      <img
                        v-if="typeof auth.userimage === 'string' && auth.userimage.length > 0"
                        class="photo"
                        title="ava"
                        :src="auth.userimage"
                        width="24"
                        height="24"
                        :alt="auth.userFullName"
                        loading="lazy"
                      />
                      <!-- <img
                          class="photo"
                          title="SOCO user"
                          v-else
                          :src="`/assets/img/avatar-soco.png`"
                          width="24"
                          height="24"
                          loading="lazy"
                        /> -->
                      <img
                        v-else
                        class="photo avatar-soco"
                        title="SOCO user"
                        :src="`/assets/img/avatar-soco.png`"
                        width="24"
                        height="24"
                        loading="lazy"
                      />
                      <i
                        class="arrow_carrot-down"
                        style="
                          color: #b22655;
                          font-size: 14px;
                          margin-top: 0;
                          display: inline-block;
                          position: absolute;
                          right: 0;
                          top: 13px;
                        "
                      ></i>
                      <span class="drop-down-wrapper">
                        <span class="drop-down-menu profile-wrap">
                          <div class="profile-img">
                            <GImageUser
                              :username="auth.username || null"
                              :src="auth.userimage"
                              class="img-user"
                              class-name="avatar"
                              :alt="auth.username || 'icon-default-avatar'"
                              :user-level="auth.userProfile.user_level"
                              :is-expert-review="isExpertReview"
                              :user="auth || null"
                            />
                          </div>
                          <div class="profile-detail">
                            <p class="name">{{ auth.userFullName }}</p>
                            <div class="username-wrapper">
                              <a class="username">@{{ auth.username }}</a>
                              <div v-if="auth.userProfile.expert_role" class="expert-role">
                                {{ convertName(auth.userProfile.expert_role) }}
                              </div>
                            </div>
                            <a :href="`${$store.state.SOCO_WEB_URL}/${auth.username}/timeline`" class="txt-danger">
                              View profile
                            </a>
                          </div>
                        </span>
                        <div id="soco-level-points" class="soco-level-points">
                          <a
                            :href="`${$store.state.SOCO_WEB_URL}/profile/points-rewards`"
                            target="_blank"
                            rel="noopener"
                          >
                            <section class="soco-level">
                              <img
                                class="lazy-img"
                                :src="getSocoLevelImage(levelForImage, '/assets/img/loyalty-point')"
                                :alt="getSocoLevelName(levelForImage)"
                                @error="onSocoLevelImageError"
                              />
                              <section>
                                <p>Beauty Star</p>
                                <img
                                  class="lazy-img user-level-caption"
                                  :src="getSocoLevelImage(levelForImage, '/assets/img/loyalty-point', '-caption')"
                                  :alt="getSocoLevelName(levelForImage)"
                                  @error="onSocoLevelImageError"
                                />
                              </section>
                            </section>
                            <section class="soco-points">
                              <img src="/assets/img/icon_sp.svg" class="lazy-img sp-icon" />
                              <section>
                                <p>Soco Points</p>
                                <span class="points">{{ auth.points.count || 0 }}</span>
                              </section>
                            </section>
                            <img src="/assets/img/arrow-right-red.svg" width="24" />
                          </a>
                        </div>
                        <a
                          :href="$store.state.SOCO_WEB_URL + '/profile/edit'"
                          class="drop-down-menu user-main-menu"
                          target="_blank"
                          rel="noopener"
                        >
                          Edit Profile
                        </a>
                        <!-- BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072 -->
                        <a id="logout" href class="drop-down-menu clickable user-logout" @click.prevent="logOut">
                          <img src="/assets/img/icon-logout.svg" class="lazy-img" />
                          <template v-if="isLogout">Logging out...</template>
                          <template v-else>Log out</template>
                        </a>
                      </span>
                    </div>
                  </div>
                  <!-- <div class="right login-page">
                      <a class="btn login" >masuk</a>
                      <a class="btn register" @click.prevent="register">daftar</a>
                    </div> -->
                  <div v-else class="right login-page" @click.prevent="onLogin">
                    <span class="login">
                      Login with
                      <!-- <img src="/assets/img/logo-header-small-soco.svg" style="margin-left: 3px; margin-right: 6px; position: relative;" class="v-lazy-image v-lazy-image-loaded"> -->
                      <!-- <i
                          class="arrow_carrot-down"
                          style="
                            color: #b22655;
                            font-size: 14px;
                            margin-top: 0;
                            display: inline-block;
                            position: absolute;
                            right: 0;
                            top: 16px;
                          "
                        ></i> -->
                    </span>
                    <SvgImg id="logo-header-small-soco" name="logo-header-small-soco" width="44" height="10" />
                  </div>
                </template>
              </div>
            </div>
            <div v-if="!registerProfilePages && !isDesktop && $route.name === 'Dashboard'" class="form-group-search">
              <img src="/assets/img/icons/input-search.svg" class="form-group-search__icon" alt="icon-search" />
              <input
                type="text"
                name="product"
                class="form-control form-control-search"
                placeholder="Search product and see review"
                readonly
                autocomplete="off"
                @focus="toggleInputSearchMobile($event)"
              />
            </div>
            <div v-if="!registerProfilePages && !isDesktop && $route.name === 'Dashboard'" class="row">
              <HeaderPrimaryMenuMobile
                v-if="!kebabMenuShowPagesList && !registerProfilePages && !closeButton && !isDesktop"
                key="HeaderPrimaryMenu"
              />
            </div>
          </template>
          <div v-else>
            <a href="" @click.prevent="registerProfileBack">
              <img src="/assets/img/arrow_left_new.svg" class="back-action" />
            </a>
            <span style="text-transform: uppercase">Complete {{ headerText }}</span>
          </div>
        </div>
      </div>
      <div v-else class="main-header">
        <div class="main-header-wrapper trans">
          <div class="container wrapper">
            <div v-if="!isDesktop" :id="'wrapper-inside-mobile-custom'" class="wrapper-inside">
              <div id="main-top-header" class="main-top-header">
                <a href="" class="toggle-menu" :title="backActionProperties.title" @click.prevent="goBack">
                  <SvgImg name="back-header-icon" width="22" height="16" alt="back-icon" />
                </a>
                <div class="head trans back-action-title" :class="{ 'expert-page': isExpertPage }">
                  <!-- eslint-disable-next-line vue/no-v-html-->
                  <span v-html="backActionProperties.title"></span>
                </div>

                <div v-if="!actionMenuHidePagesList" class="actionhead trans">
                  <ul class="action-login">
                    <li
                      v-if="
                        !isDesktop &&
                        ($route.name === 'BrandDetail' || $route.name === 'Category' || $route.name === 'Search')
                      "
                    >
                      <span
                        v-if="$route.name === 'Search'"
                        id="searchIconArea"
                        class="basic-icon--uniform close-grey-icon"
                        @click.prevent="toggleInputSearchMobile($event)"
                      ></span>
                      <span
                        v-else
                        id="searchIconArea"
                        class="basic-icon--uniform"
                        :class="!searchPopup ? 'icon-search' : 'icon-close'"
                        @click.prevent="toggleInputSearchMobile($event)"
                      ></span>
                    </li>
                    <li v-if="!isDesktop && kebabMenuShowPagesList" class="three-dots kebab-menu-header">
                      <a ref="anchorDots" href="javascript:;" @click="threeDotsClick()">
                        <SvgImg
                          name="three-dots"
                          width="4"
                          height="18"
                          class="kebab-menu-header"
                          alt="Three dots icon"
                        />
                      </a>
                      <div :class="{ active: showThreeDots }" class="three-dots-menu trans">
                        <ul>
                          <li @click="goTo('')">
                            <figure>
                              <SvgImg name="home" width="15" height="15" alt="Home icon" />
                            </figure>
                            <span>Back to Home</span>
                          </li>
                          <li v-if="showingModalTellFriends" @click="goTo('share')">
                            <figure>
                              <SvgImg name="share-icon" class="icon-share" width="15" height="15" />
                            </figure>
                            <span>Share</span>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- wrapper-inside -->
            <div
              v-if="!registerProfilePages"
              id="searchArea"
              class="col-xs-center col-xs-12 search-area-new"
              :class="{ active: searchPopup }"
            >
              <div class="input-search-header">
                <a v-if="!screen.isDesktop" href="" @click.prevent="hideSearchPopup">
                  <img src="/assets/img/arrow_left_new.svg" class="back-action" />
                </a>
                <input
                  v-model="querySearch"
                  type="text"
                  class="form-control"
                  placeholder="Search..."
                  autocomplete="off"
                  @focus="
                    fetchFocus();
                    showSearchPopup();
                  "
                  @keyup.exact="fetchSuggestion($event)"
                  @keyup.enter="searching()"
                />
                <!-- @blur="hideSearchPopup()" -->

                <transition name="fade">
                  <div
                    v-if="searchPopup"
                    ref="sectionSuggested"
                    class="search-suggest"
                    :class="{ 'no-result': noResultSearch }"
                  >
                    <div v-if="querySearch.length > 1" class="search-result-wrap">
                      <div
                        v-if="suggestions.brands && suggestions.brands.length"
                        class="result-popular-brands suggestion-results"
                      >
                        <h4 class="suggestion-results__heading">suggested brand</h4>
                        <ul class="list-popular-brand list-scrollable">
                          <li
                            v-for="(b, idx) in suggestions.brands"
                            :key="idx"
                            @click="saveSearchHistoryClicks(b._id, 'brand')"
                          >
                            <router-link
                              class="brand-logo-wrapper"
                              :to="`/brand/${b.my_soco_sql_id}/${$options.filters.slug(b.name)}`"
                            >
                              <img
                                v-if="b.logo"
                                :src="mainImage(b.logo)"
                                :alt="'Sociolla - ' + b.name"
                                class="brand-logo"
                                @error="brandImageErrorHandler($event)"
                              />
                              <img
                                v-else
                                src="/assets/img/dummy_product.svg"
                                class="brand-logo error-brand"
                                alt="no image"
                              />
                            </router-link>
                          </li>
                        </ul>
                      </div>

                      <div v-if="suggestedTag.length" class="suggestion-results">
                        <!-- <h4 class="suggestion-results__heading">SUGGESTED SKIN CONCERN</h4> -->
                        <ul class="list-scrollable">
                          <li v-for="(tag, key) in suggestedTag" :key="`suggest-tag-concern${key}`">
                            <!-- <router-link :to="`/tag/${tag.url_search}`" class="pill pill__tags"> -->
                            <router-link :to="`/search?query=${tag.url_search}`" class="pill pill__tags">
                              <img v-if="tag.icon" :src="tag.icon" class="tag-icon" :alt="'Concern - ' + tag.name" />{{
                                tag.name
                              }}
                            </router-link>
                          </li>
                        </ul>
                      </div>

                      <!-- SUGGESTED BRANDS -->
                      <div
                        v-if="suggestions.brands && suggestions.brands.length"
                        class="result-brands suggestion-results"
                      >
                        <h4 class="suggestion-results__heading">suggested brand</h4>
                        <div class="suggestion-results__brand">
                          <ul class="list-suggest-brand list-scrollable">
                            <li v-for="(brand, key) in suggestions.brands" :key="key">
                              <router-link
                                :key="key + 'srb'"
                                :to="brandLink(brand)"
                                class="brand-logo-wrapper"
                                @click.native="savedBrandToHistory(brand)"
                              >
                                <lazy-img
                                  :lazy-src="mainImage(brand.logo)"
                                  class="brand-logo"
                                  :alt="'Sociolla - ' + brand.name"
                                  @onerror="src = '/assets/img/default_img_brand.svg'"
                                />
                              </router-link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <!-- SUGGESTED PRODUCTS -->
                      <div
                        v-if="suggestions.products && suggestions.products.length"
                        class="result-trending-products suggestion-results suggestion-results--suggestion-products"
                      >
                        <h4 class="suggestion-results__heading">suggested product</h4>
                        <ul class="list list-trending-products list-suggestion-products">
                          <li
                            v-for="(prodRslt, idx) in suggestions.products"
                            :key="idx"
                            @click="saveSearchHistoryClicks(prodRslt.id, 'product')"
                          >
                            <GProduct
                              v-if="prodRslt"
                              :inline-reviewers="true"
                              :hide-average-rating="false"
                              class="list-to-review__nowrap"
                              class-modifier="product--inline-navbar"
                              :hide-total-reviews="true"
                              :hide-combinations="true"
                              :right-btn-review="true"
                              :product="prodRslt"
                              :section="`navbar`"
                            />
                          </li>
                        </ul>
                        <!-- <infinite-loading @infinite="infiniteHandler">
                          <div slot="no-more"></div>
                          <div slot="no-results"></div>
                          <div slot="spinner"><GLoaderSpin /></div>
                        </infinite-loading> -->
                      </div>
                    </div>

                    <div v-if="!querySearch" class="search-result-wrap">
                      <template v-if="isLogin">
                        <div v-if="recentlySearch.length" class="result-recently-search suggestion-results">
                          <h4 class="suggestion-results__heading">
                            recently searched
                            <span
                              v-if="recentlySearch.length"
                              class="result-recently-search__clear"
                              @click.prevent="clear"
                            >
                              Clear
                            </span>
                          </h4>

                          <ul class="list-scrollable list-recently-search">
                            <li v-for="(history, key) in recentlySearch" :key="`list-recently-search${key}`">
                              <router-link
                                :to="`/search?query=${history.keyword}`"
                                class="pill pill__recently-search pill--with-close"
                              >
                                {{ history.keyword }}
                                <span
                                  class="pill__dismiss"
                                  @click.prevent="remove({ key: key, history: history })"
                                ></span>
                              </router-link>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="result-recently-search suggestion-results">
                          <LoaderSpin key="isLoadingRecentylySearch" />
                        </div>
                      </template>

                      <template v-if="isLogin">
                        <div v-if="recentlyProductViewed.length" class="result-recently-view suggestion-results">
                          <h4 class="suggestion-results__heading">recently viewed</h4>
                          <ul class="list-scrollable list-recently-viewed">
                            <li v-for="(recentlyReview, key) in recentlyProductViewed" :key="key">
                              <router-link
                                v-if="recentlyReview.product && recentlyReview.product.is_active_in_review"
                                :to="$options.filters.productUrlReview(recentlyReview.product)"
                                target="_blank"
                                rel="noopener"
                              >
                                <figure class="product-image">
                                  <img
                                    v-if="
                                      recentlyReview.product.product_images &&
                                      recentlyReview.product.product_images.length > 0 &&
                                      recentlyReview.product.product_images[0].url
                                    "
                                    :src="mainImage(recentlyReview.product.product_images[0].url)"
                                    alt=""
                                    width="50"
                                  />
                                  <img v-else src="https://images.soco.id/300x300.png" width="50" />
                                </figure>
                              </router-link>
                              <a
                                v-else
                                :href="$options.filters.productLinkV3(recentlyReview.product)"
                                target="_blank"
                                rel="noopener"
                              >
                                <figure class="product-image">
                                  <img
                                    v-if="
                                      recentlyReview.product.product_images.length > 0 &&
                                      recentlyReview.product.product_images[0].url
                                    "
                                    :src="recentlyReview.product.product_images[0].url"
                                    alt=""
                                    width="50"
                                  />
                                  <img v-else src="https://images.soco.id/300x300.png" width="50" />
                                </figure>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </template>

                      <!-- TRENDING SEARCH -->
                      <div
                        v-if="trendingSearchData && trendingSearchData.length"
                        class="result-recently-search suggestion-results"
                      >
                        <h4 class="suggestion-results__heading">trending search</h4>
                        <ul ref="list-trending-search--result" class="list-scrollable list-recently-search">
                          <li v-for="(trending, key) in trendingSearchData" :key="`list-trending-search--result${key}`">
                            <router-link :to="`/search?query=${trending}`" class="pill pill__tags">
                              <img src="/assets/img/popular.svg" alt="Popular" class="tag-icon" />
                              {{ trending }}
                            </router-link>
                          </li>
                        </ul>
                      </div>

                      <div v-if="tagConcern.length" class="result-recently-search suggestion-results">
                        <h4 id="review-tag-0" class="suggestion-results__heading">skin concern</h4>
                        <ul class="list-scrollable list-recently-search">
                          <li v-for="(tag, key) in tagConcern" :key="`list-tag-concern${key}`">
                            <!-- <router-link :to="`/tag/${tag.url_search}`" class="pill pill__tags"> -->
                            <router-link :to="`/search?query=${tag.url_search}`" class="pill pill__tags">
                              <img v-if="tag.icon" :src="tag.icon" class="tag-icon" :alt="'Concern - ' + tag.name" />{{
                                tag.name
                              }}
                            </router-link>
                          </li>
                        </ul>
                      </div>

                      <div class="result-popular-brands suggestion-results">
                        <h4 class="suggestion-results__heading">popular</h4>
                        <ul class="list-popular-brand list-scrollable">
                          <li v-for="(b, idx) in exclusiveAndTrendingTabs[activeTab].brands" :key="idx">
                            <!-- <router-link class="brand-logo-wrapper" :to="`/brand/${b.my_soco_sql_id}/${b.name}`"> -->
                            <router-link class="brand-logo-wrapper" :to="`/search?query=${b.name}`">
                              <img
                                v-if="b.logo"
                                :src="mainImage(b.logo)"
                                alt="Sociolla - Maybelline"
                                class="brand-logo"
                                @error="brandImageErrorHandler($event)"
                              />
                              <img
                                v-else
                                src="/assets/img/dummy_product.svg"
                                class="brand-logo error-brand"
                                alt="no image"
                              />
                            </router-link>
                          </li>
                        </ul>
                      </div>

                      <div class="result-trending-products suggestion-results">
                        <ul class="list list-trending-products">
                          <li
                            v-for="(product, index) in exclusiveAndTrendingTabs[activeTab].products"
                            :key="index"
                            @click="saveSearchHistoryClicks(product.id, 'product')"
                          >
                            <GProduct
                              :inline-reviewers="true"
                              :hide-average-rating="false"
                              class="list-to-review__nowrap"
                              class-modifier="product--inline-navbar"
                              :hide-total-reviews="true"
                              :hide-combinations="true"
                              :right-btn-review="true"
                              :product="product"
                              :section="`navbar`"
                            />
                          </li>
                        </ul>
                      </div>
                    </div>

                    <template
                      v-if="
                        noResultSearch &&
                        !(suggestions.products && suggestions.products.length) &&
                        !(suggestions.brands && suggestions.brands.length)
                      "
                    >
                      <!-- NO RESULT FOUND -->
                      <div class="no-result-found">
                        <div class="no-result-found--image">
                          <SvgImg class="lazy-img" name="product-not-found" width="72" height="65" />
                        </div>
                        <p class="no-result-found--text">Sorry dear, no suggestion found</p>
                        <p class="no-result-found--subtext">We cant find any brand & product matching your search</p>
                      </div>
                    </template>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop />
      <template v-if="!isDesktop">
        <transition name="drawer">
          <TheDrawer v-show="isOffCanvasOpen" />
        </transition>
      </template>
    </div>

    <HeaderPrimaryMenu
      v-if="!kebabMenuShowPagesList && !registerProfilePages && !closeButton && isDesktop"
      key="HeaderPrimaryMenu"
    />

    <!--
      <OffCanvas key="OffCanvas" />
    -->

    <BrowseByBrandsMobile v-if="!isDesktop && $store.state.filterProduct.browseBy.brand" />
    <BrowseCategoriesMobile v-if="!isDesktop && $store.state.header.showCategoriesMobile" />
  </header>
</template>

<script>
import debounce from 'lodash.debounce';
import Auth from '@/shared/auth';
import ClickOutside from 'vue-click-outside';
import { LEVEL_CODES, socoLevelMixin } from '@/shared/soco-levels';
const Config = require('~/config/default.env').default;
// import ButtonCreate from './snippet/button-create';
// import TheDrawer from '../drawer/TheDrawer';
// import Backdrop from '@/components/global/backdrop/Backdrop';
// import HeaderPrimaryMenu from './snippet/header-primary-menu';
// import BrowseByBrandsMobile from '@/components/global/browse-by-brands/browse-by-brands-mobile.vue';
// import OffCanvas from "./snippet/off-canvas";

export default {
  name: 'my-navbar',
  components: {
    ButtonCreate: () => import('./snippet/button-create'),
    TheDrawer: () => import('../drawer/TheDrawer'),
    Backdrop: () => import('@/components/global/backdrop/Backdrop'),
    HeaderPrimaryMenu: () => import('./snippet/header-primary-menu'),
    BrowseByBrandsMobile: () => import('@/components/global/browse-by-brands/browse-by-brands-mobile.vue'),
    SearchPlaceholder: () => import('@/components/global/navbar/snippet/search-placeholder'),
    HeaderPrimaryMenuMobile: () => import('@/components/global/navbar/snippet/header-primary-menu-mobile'),
    BrowseCategoriesMobile: () => import('@/components/global/navbar/snippet/browse-category-mobile'),
    // OffCanvas,
  },
  directives: {
    ClickOutside,
  },
  mixins: [socoLevelMixin],
  data() {
    return {
      isLoading: {
        brandsResult: true,
        popularProducts: true,
        productResults: true,
        trendingSearch: true,
      },
      initialLoading: true,
      recentlySearch: [],
      recentlyProductViewed: [],
      cancelSource: null,
      popularProducts: [],
      popularBrands: [],
      tagConcern: [],
      brandsResult: [],
      productResults: [],
      listTrendingSearch: [],
      querySearch: '',
      isLogout: false,
      showLoginModal: false,
      isLoadingRecentylySearch: false,
      isLoadingRecentylyProductViewed: false,
      searchPopup: false,
      activeTab: 'trending',
      activeRelatedTab: 'best_seller',
      debouncedKeyword: '',
      searchProductInfo: {
        limit: 3,
        skip: 0,
      },
      showThreeDots: false,
      tours: [
        {
          title: 'Search by Skin Concern',
          content:
            '<p>Hai, sekarang kamu dapat melakukan pencarian berdasarkan kondisi kulitmu seperti jerawat, komedo, kantung mata dan lain-lain. Selamat mencari!</p>',
          arrow: 'top-left',
          arrow_mobile: 'top-left',
          position: 'bottom',
          id: 'review-tag-0',
          coachmark: 'review_search_tag',
          index: 0,
          highlightStyle: '',
          style: 'width:290px;left:unset;right:unset;padding:20px;',
          next_title: 'OK',
          overlay: false,
        },
      ],
    };
  },

  computed: {
    auth() {
      return this.$store.state.auth;
    },
    categoriesOfDepartment() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    isOffCanvasOpen() {
      return this.$store.state.header.isOffCanvasOpen;
    },
    screen() {
      return this.$store.state.screen;
    },
    showButtonCreated() {
      if (/review[/]add/.test(this.$route.path)) {
        return false;
      } else {
        return true;
      }
    },
    noResultSearch() {
      return !this.productResults.length && !this.brandsResult.length && this.querySearch.length > 1;
    },
    registerProfilePages() {
      return ['BeautyProfile', 'Recommendation', 'RegisterDetail'].includes(this.$route.name);
    },
    headerText() {
      return this.$route.path.substring(1).split('-').join(' ');
    },
    kebabMenuShowPagesList() {
      const routeName = this.$route.name;
      const pageslist = [
        'productDetail',
        'BrandDetail',
        'Category',
        'TagConcern',
        'ProductMatch',
        'ProductMatchCategory',
        'ExpertPage',
        'ExpertUsers',
        'OurCuratedSelections',
      ];
      return pageslist.includes(routeName) && !this.$store.state.screen.isDesktop;
    },
    actionMenuHidePagesList() {
      const routeName = this.$route.name;
      const pageslist = ['ExpertUsers'];
      return pageslist.includes(routeName) && !this.$store.state.screen.isDesktop;
    },
    closeButton() {
      const routeName = this.$route.name;
      const pageslist = ['Search', 'TagConcern', 'ProductMatch', 'ProductMatchCategory'];
      return pageslist.includes(routeName) && !this.$store.state.screen.isDesktop;
    },
    backActionProperties() {
      let title = this.$store.state.header.page_info_title ? this.$store.state.header.page_info_title : '';
      title = title.slice(0, 25) + (title.length > 25 ? '...' : '');
      title = this.filterText(title);
      return {
        title,
      };
    },
    showingModalTellFriends() {
      const routeName = this.$route.name;
      if (routeName === 'productDetail' || routeName === 'BrandDetail') {
        return true;
      } else {
        return false;
      }
    },
    suggestedTag() {
      if (this.productResults.length && this.tagConcern.length && this.querySearch.length > 1) {
        return this.tagConcern.filter((tag) => new RegExp(this.querySearch.toLowerCase()).test(tag.name.toLowerCase()));
      } else {
        return [];
      }
    },
    listTours() {
      return this.$store.state.tours;
    },
    trendingSearchData() {
      return this.$store.state.$_SearchHeader.trendingSearch;
    },
    searchLoading() {
      return this.$store.state.$_SearchHeader.loading;
    },
    exclusiveAndTrendingTabs() {
      const tabs = JSON.parse(JSON.stringify(this.$store.state.$_SearchHeader.exclusiveAndTrendingTabs));
      // for (const key of Object.keys(tabs)) {
      //   if (!tabs[key].brands.length && !tabs[key].products.length) {
      //     delete tabs[key];
      //   }
      // }
      return tabs;
    },
    isLoadingSuggestion() {
      return Boolean(this.keyword && this.searchLoading);
    },
    search() {
      return this.$store.state.$_SearchHeader;
    },
    suggestions() {
      return this.search.suggestions;
    },
    negativeScenarioSimilarWords() {
      const { suggestions } = this;
      return Boolean(
        !(suggestions.category && suggestions.category.length) &&
          !(suggestions.banner && suggestions.banner.length) &&
          !(suggestions.tags && suggestions.tags.length) &&
          !suggestions.exact_brand &&
          !suggestions.exact_product &&
          !suggestions.exact_tag
      );
    },
    suggestionsTags() {
      const {
        suggestions: { tags },
      } = this;
      if (tags.length > 3) {
        return tags.slice(0, 3);
      }
      return tags;
    },
    // showSearchForm() {
    //   if ('$_Header' in this.$store._modules.root._children) {
    //     if (this.$_Screen.isDesktop) {
    //       this.searchTopMobile();
    //     }
    //     return this.$store.state.$_Header.show_search_form;
    //   }
    // },
    // eslint-disable-next-line vue/return-in-computed-property
    showSearchResult() {
      if ('show_search' in this.search) {
        return this.search.show_search;
      }
    },
    isExpertPage() {
      return ['ExpertPage', 'ExpertUsers'].includes(this.$route.name);
    },
    isExpertReview() {
      return this.$store.state.auth.userProfile.is_expert_reviewer;
    },
    userLevel() {
      const userProfile = this.$store.state.auth && this.$store.state.auth.userProfile;
      return (userProfile && userProfile.user_level) || '';
    },
    // level for the badge and caption images: the lowest level when the member has none
    levelForImage() {
      return this.userLevel || LEVEL_CODES.MEMBER;
    },
  },
  watch: {
    '$store.state.header.showCategoriesMobile': function (newVal, oldVal) {
      const body = document.getElementsByTagName('body')[0].classList;
      body[newVal ? 'add' : 'remove']('drawer-open');
    },
    isLogin(newVal) {
      const isResetStateLogout = newVal && this.isLogout;
      if (isResetStateLogout) {
        this.isLogout = false;
      }

      if (newVal) {
        // this.fetchRecentlySearch();
        // this.fetchRecentlyViewed();
      }
    },
    $route(to, from) {
      if (to.name === 'Dashboard') {
        this.querySearch = '';
      }
      if (to !== from) {
        this.searchPopup = false;
        this.showThreeDots = false;
        this.querySearch = '';
      }
    },
    searchPopup() {
      // if (!this.screen.isDesktop) {
      if (this.searchPopup) {
        const overlayElement = document.createElement('div');
        const bodyElement = document.querySelector('body');
        overlayElement.setAttribute('id', 'overlayStyle');
        bodyElement.appendChild(overlayElement);
        this.$SO('body').addClass('no-scroll');
        this.$SO('body').addClass('header-full-fixed');
      } else {
        const overlayElement = document.getElementById('overlayStyle');
        if (overlayElement) {
          overlayElement.remove();
        }
        this.$SO('body').removeClass('no-scroll');
        this.$SO('body').removeClass('header-full-fixed');
      }
      // }
    },

    isOffCanvasOpen(newValue) {
      const body = document.getElementsByTagName('body')[0].classList;

      return newValue ? body.add('drawer-open') : body.remove('drawer-open');
    },

    querySearch(newVal) {
      if (this.querySearch && this.querySearch.length < 1) {
        commit('SET_SUGGESTION', {
          suggestions_keyword: '',
        });
      }
    },

    // exclusiveAndTrendingTabs: {
    //   deep: true,
    //   handler(tabs) {
    //     const keys = Object.keys(tabs);
    //     if (keys.length) {
    //       this.activeTab = keys[0];
    //     }
    //   },
    // },
  },
  mounted() {
    // window.addEventListener("scroll", this.headerToScroll, {
    //   capture: true,
    //   passive: true,
    //   behavior: "smooth",
    // });
  },
  destroyed() {
    document.removeEventListener('scroll', this.headerToScroll);
    document.removeEventListener('click', this.documentClick);
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  methods: {
    convertName(name) {
      let result = '';
      result = name
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      return result;
    },
    async fetchTrendingSearch() {
      return this.$store.dispatch('$_SearchHeader/fetchTrendingSearch');
    },
    async fetchExclusiveAndTrendingTabs() {
      return this.$store.dispatch('$_SearchHeader/fetchExclusiveAndTrendingTabs').then((data) => {
        if (data.trending && !data.new_exclusive) {
          this.activeTab = 'trending';
        }
        this.initialLoading = false;
      });
    },

    // headerToScroll(event) {
    //   try {
    //     var that = this,
    //     el = document.getElementById('main_header__v2');

    //     if(el){
    //       var _this = that,
    //       scrollY = window.pageYOffset || document.documentElement.scrollTop,
    //       header = el;

    //       if (scrollY > header.offsetTop) {
    //         header.classList.add("sticky");
    //       } else {
    //         header.classList.remove("sticky");
    //       }
    //     }
    //   } catch (error) {console.log(error)}
    // },

    filterText(text) {
      return text ? text.replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';
    },
    threeDotsClick() {
      this.showThreeDots = this.showThreeDots ? false : true;
    },
    goTo(data) {
      if (data) {
        if (data === 'share') {
          if (this.$route.name == 'productDetail' ? this.$store.state.modal.productData : true) {
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'tellFriends',
            });
          }
          return;
        }
      } else {
        this.$router.replace('/');
      }
    },
    goBack() {
      if (this.$route.name === 'ProductMatch' && 'beauty-profile' in this.$route.query) {
        this.$router.push({ query: Object.assign({}) });
      } else if (this.$route.name === 'ProductMatchCategory') {
        this.$router.push('/our-curated-selection');
      } else if (this.$route.name === 'ExpertPage') {
        this.$router.push('/');
      } else {
        if (this.$route.name === 'Search') {
          this.$store.commit('$_SearchHeader/SET_SUGGESTION', {
            suggestions_keyword: '',
            brands: [],
            products: [],
            tags: [],
            banner: [],
            category: [],
          });
        }
        this.$store.state.header.page_info_title = '';
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
      }
    },
    saveSearchHistoryClicks(entity_id, entity_type) {
      if (!this.isLogin) {
        return;
      }
      const params = {
        entity_id: entity_id, // id product
        keyword: this.querySearch, // keyword yg dimasukin
        entity_type: entity_type,
      };
      return axios.post(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-clicks`, params);
    },
    saveCategoriesToHistory(category) {
      if (this.isLogin) {
        this.$store.dispatch('$_Header/savedSearchHistory', {
          entity_id: category._id,
          keyword: this.keyword || category.name,
          entity_type: 'categories',
        });
      }
    },
    clear() {
      axios
        .delete(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-keywords-clear`)
        .then((response) => {
          if (response.status === 200) {
            this.recentlySearch = '';
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    documentClick(e) {
      const target = e.target;
      if (this.searchPopup && this.screen.isDesktop) {
        if (
          this.$SO(target).closest('#searchArea').length < 1 &&
          this.$SO(target)[0] !== this.$SO('#searchIconArea')[0] &&
          this.$SO(target).closest('#quick-tour').length < 1
        ) {
          this.searchPopup = false;
        }
      }
    },
    searching() {
      this.searchPopup = false;
      this.searchProductInfo.skip = 0;
      if (this.querySearch.length > 1) {
        // this.savedSearchHistory({
        //   "entity_id": 'product',
        //   "keyword": this.querySearch
        // })
        this.$store.dispatch('$_Header/savedSearchHistory', {
          entity_id: null,
          keyword: this.querySearch.trim(),
        });

        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'q',
          value: this.querySearch.trim(),
        });
        this.$router.push({
          path: '/search',
          query: {
            query: this.querySearch.trim(),
          },
        });
        setTimeout(() => {
          this.savedKeyword();
          this.cancelSearch();
          this.hideSearchPopup();
        }, 501);
      }
    },
    savedKeyword() {
      if (this.querySearch) {
        this.$store.dispatch('addSearchHistory', {
          entity_id: null,
          keyword: this.querySearch,
        });
      }
    },
    cancelSearch() {
      // this.suggestionResults = [];
      this.productResults = [];
      this.noResult = false;
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    fetchSuggestion: debounce(function (e) {
      //fetchSuggestion(e) {
      if (!this.querySearch.length) {
        this.fetchFocus();
      }
      if (this.querySearch.length < 3) {
        this.cancelSearch();
        return;
      }

      if (typeof this.cancelSource !== 'undefined') {
        this.cancelSearch();
      }
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      // this.getSearchSuggestion();
    }, 500),
    hideSearchPopup() {
      const thisel = this;
      setTimeout(function () {
        thisel.searchPopup = false;
        thisel.querySearch = '';
      }, 200);
    },
    showSearchPopup() {
      this.searchPopup = true;
    },
    getTrendingSearch() {
      this.isLoading.trendingSearch = true;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/random`, {
          params: {
            fields: 'id name brand images review_stats total_reviews default_category parent_category',
            filter: { 'review_stats.total_reviews': { $gte: 5, $lte: 100 } },
            limit: 3,
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            this.listTrendingSearch = response.data.data;
          } else {
            this.listTrendingSearch = [];
          }

          this.isLoading.trendingSearch = false;
        })
        .catch((err) => {
          this.listTrendingSearch = [];
          this.isLoading.trendingSearch = false;
        });
    },
    searchSuggestion: debounce(function (e) {
      this.debouncedKeyword = this.querySearch;
      if (this.querySearch.length > 0) {
        this.searchPopup = true;
      }
      if (this.querySearch.length === 0 && e && e.code !== 'Enter') {
        this.searchPopup = true;
        this.$store.commit('$_SearchHeader/SET_SUGGESTION', { suggestions_keyword: '' });
      }
      if (this.querySearch.length >= 3 && e && e.code !== 'Enter') {
        this.$store.dispatch('$_Header/savedSearchHistory', {
          entity_id: null,
          keyword: this.querySearch,
        });
        this.setLoading(true);
        Promise.all([this.fetchSuggestionsV2(), this.fetchEventSuggestions()]).finally(() => {
          this.setLoading(false);
        });

        if (!this.showSearchResult) {
          this.$store.dispatch('$_SearchHeader/showSearch', true);
        }
      } else {
        if (this.showSearchResult) {
          this.$store.dispatch('$_SearchHeader/showSearch', false);
        }
      }
    }, 500),
    async fetchSuggestionsV2() {
      this.$store.commit('$_SearchHeader/ASSIGN_SUGGESTION', {
        key: 'fetched',
        data: false,
      });
      return this.$store.dispatch('$_SearchHeader/fetchSuggestionsV2', this.querySearch);
    },
    async fetchEventSuggestions() {
      return this.$store.dispatch('$_SearchHeader/fetchEventSuggestions', this.querySearch);
    },
    getPopularProducts() {
      this.isLoading.popularProducts = true;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/featured/trending`, {
          params: {
            filter: { is_reviewed: true },
            fields: 'id name brand images review_stats total_reviews default_category parent_category',
            section: 'TrendingProducts',
            limit: 3,
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            this.popularProducts = response.data.data;
          } else {
            this.popularProducts = [];
          }

          this.isLoading.popularProducts = false;
        })
        .catch((err) => {
          this.popularProducts = [];
          this.isLoading.popularProducts = false;
        });
    },
    fetchRecentlySearch() {
      if (this.isLogin && !this.isRecentylySearchFetched) {
        this.isLoadingRecentylySearch = true;
        this.$MS_SOCO_PUBLIC_API_URL
          .get(`/search-history-keywords`, {
            params: {
              limit: 5,
              // filter: {
              //   source_from: 'review'
              // }
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.recentlySearch = response.data.data;
            } else {
              this.recentlySearch = [];
            }
            this.isLoadingRecentylySearch = false;
          })
          .catch((err) => {
            this.recentlySearch = [];
            this.isLoadingRecentylySearch = false;
            // console.log(err);
          });
      }
    },
    fetchRecentlyViewed() {
      if (this.isLogin) {
        this.isLoadingRecentylyProductViewed = true;
        this.$MS_SOCO_PUBLIC_API_URL
          .get(`/search-history-clicks`, {
            params: {
              filter: { entity_type: 'product' },
              limit: 5,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.recentlyProductViewed = response.data.data;
            } else {
              this.recentlyProductViewed = [];
            }
            this.isLoadingRecentylyProductViewed = false;
          })
          .catch((err) => {
            this.recentlyProductViewed = [];
            this.isLoadingRecentylyProductViewed = false;
            // console.log(err);
          });
      }
    },
    fetchPopularBrands() {
      axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/brands`, {
          params: {
            filter: {
              is_featured: true,
            },
            sort: '-total_reviews',
            skip: 0,
            limit: 5,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.popularBrands = response.data.data;
          } else {
            this.popularBrands = [];
          }
        })
        .catch((err) => {
          this.popularBrands = [];
        });
    },
    fetchTagConcern() {
      axios
        .get(`${Config.MS_CATALOG_API_URL}/tags`, {
          params: {
            filter: {
              is_show_in_search: true,
              level_name: 'Concern',
            },
            limit: 5,
            fields: '_id name icon',
          },
        })
        .then((response) => {
          let value = [];
          if (response.status === 200) {
            value = response.data.data.map((x) => {
              const newData = Object.assign({}, x);
              newData['url_search'] = x.name.toLowerCase().replace(' ', '-');
              return newData;
            });
          }
          this.tagConcern = value;
          setTimeout(() => {
            if (this.tagConcern.length && this.listTours.length === 0) {
              this.$store.commit('setTours', this.tours);
              this.$store.dispatch('showTour', {
                index: 0,
                coachmark: 'review_search_tag',
              });
            } else if (this.tagConcern.length && this.listTours.length) {
              this.$store.dispatch('showTour', {
                index: 0,
                coachmark: 'review_search_tag',
              });
            }
          }, 100);
        })
        .catch(() => (this.tagConcern = []));
    },
    fetchFocus() {
      if (!this.querySearch.length || (!this.screen.isDesktop && !this.searchPopup)) {
        this.fetchRecentlySearch();
        this.fetchRecentlyViewed();
        this.fetchTagConcern();
        this.fetchTrendingSearch();
        this.fetchExclusiveAndTrendingTabs();
      } else {
        this.listTrendingSearch = [];
        this.popularProducts = [];
      }
    },
    hideMenu() {
      this.changemegaMenuStats(null);
    },
    infiniteHandler($state) {
      if (this.isLoading.productResults) {
        return;
      }
      this.isLoading.productResults = true;
      this.searchProductInfo.skip += this.searchProductInfo.limit;
      axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/search`, {
          params: {
            filter: {
              keyword: this.querySearch,
              name: { $ne: null },
              brand: { $ne: null },
              is_active_in_review: true,
            },
            fields: 'id name brand images review_stats total_reviews default_category price parent_category',
            limit: this.searchProductInfo.limit,
            skip: this.searchProductInfo.skip,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.productResults = this.productResults.concat(response.data.data);
            if (!this.$SO.size(response.data.data)) {
              $state.complete();
              return;
            }
          } else {
            $state.complete();
            this.productResults = this.productResults.concat([]);
            return;
          }
          $state.loaded();
          this.isLoading.productResults = false;
        })
        .catch((err) => {
          this.productResults = this.productResults.concat([]);
          $state.complete();
          this.isLoading.productResults = false;
        });
    },
    changemegaMenuStats(stats) {
      if (this.megaMenuStats === stats) {
        this.megaMenuStats = null;
      } else {
        this.megaMenuStats = stats;
      }
    },
    remove({ key, history }) {
      axios
        .delete(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-keywords/${history['_id']}`)
        .then((response) => {
          if (response.status === 200) {
            this.recentlySearch.splice(key, 1);
            this.fetchRecentlySearch();
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    toggleInputSearchMobile(e) {
      this.searchPopup = !this.searchPopup;
      if (this.popularProducts.length < 1) {
        this.fetchFocus();
      } else {
        if (this.tagConcern.length && this.listTours.length && this.searchPopup) {
          setTimeout(() => {
            this.$store.dispatch('showTour', {
              index: 0,
              coachmark: 'review_search_tag',
            });
          }, 100);
        }
      }
    },
    toggleOffCanvas(e) {
      if (this.isOffCanvasOpen) {
        this.$store.commit('closeOffCanvas');
      } else {
        this.$store.commit('openOffCanvas');
      }
    },
    toggleModalAuth() {
      this.$store.commit('modalAuth', 1);
    },
    setModalState(state) {
      this.$store.commit('setDataModal', {
        modalName: 'loginPage',
        value: state,
      });
    },
    logOut() {
      this.isLogout = true;
      Auth.CentralAuth.logout();
    },
    register() {
      this.$store.commit('modalAuth', 2);
    },
    registerProfileBack() {
      const profileState = this.$store.state.profile;
      if (profileState.beautyProfileStep.current === 1) {
        this.$route.push('/');
      } else {
        this.$store.commit('setBeautyProfileStep', profileState.beautyProfileStep.current - 1);
      }
    },
    setLoading(value) {
      this.$store.commit('$_SearchHeader/SET_LOADING', value);
    },
    partialBold(str) {
      const uppercaseString = str.toUpperCase();
      const keyword = this.querySearch.toUpperCase();
      const index = uppercaseString.indexOf(keyword);
      if (!keyword || index === -1) {
        return str;
      }
      const keywordLength = keyword.length;
      return (
        str.substr(0, index) + '<b>' + str.substr(index, keywordLength) + '</b>' + str.substr(index + keywordLength)
      );
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=128' : 'w=144',
        image: src,
      });
    },
    brandImageErrorHandler(e) {
      e.target.src = '/assets/img/dummy_product.svg';
    },
    onLogin() {
      Auth.CentralAuth.login();
    },
  },
};
</script>
<style scoped>
.sociolla-universe-v1-min-height-home {
  min-height: 170px !important;
}
</style>
